// Add click handler for color variants in collection
document.addEventListener('click', function(e) {
  const colorOption = e.target.closest('.variant-color-option');
  if (!colorOption) return;
  
  const productCard = colorOption.closest('.product-collection');
  const variantId = colorOption.dataset.variantId;
  
  // Get product data
  const productData = JSON.parse(productCard.querySelector('.data-json-product').textContent);
  const variant = productData.variants.find(v => v.id == variantId);
  
  if (variant && variant.featured_image) {
    const img = productCard.querySelector('.image_product img');
    if (img) {
      img.src = variant.featured_image.src.replace(/\.(jpg|jpeg|png|webp)/i, '_300x.$1');
    }
  }
  
  // Update active state
  productCard.querySelectorAll('.variant-color-option').forEach(opt => opt.classList.remove('active'));
  colorOption.classList.add('active');
});